//TODO: (elior) - Refactor this into a Standard Class.

/**
 * Created by eliorc on 11/5/14.
 */

/**
 * @constructor
 */
//var HtmlTextFilter =
define(function (require) {

    var NO_CONTENT_TAGS = ['SCRIPT', 'NOSCRIPT', 'STYLE', 'INPUT', 'META', 'EMBED', 'OBJECT', 'IFRAME'];
    var DEFAULT_DIRECTIVES = {
        'BR': function (elm) {
            var newElement = document.createElement('BR');
            var output = newElement.outerHTML;
            newElement = null;
            return output;
        }
    };
    var DEFAULT_STYLE_ATTRIBUTES = null;

    /**
     * @param [options] {   directives:       { dictionary of HTML tags with functions to process the element},
     *                      styleAttributes:  { dictionary of style attributes paired with array of allowed values}
     *                      example:
     *                      directives: {
     *                          'A': function(element){
     *                          // process the HTML in here and return the text representation you need.
     *                          return 'text';
     *                      },
     *                      // this list will allow saving style attributes, the font weight with the values of bold or normal only,
     *                      // the other attributes in the object will be ignored.
     *                      styledAttributes: {
     *                          'font-weight': ['bold','normal]
     *                      }
     *                  }
     * @returns {{processHTML: processHTML}}
     * @constructor
     */
    var HtmlTextFilter = function (options) {
        // extend the default directive's with the directives from the options.
        var directives = {};
        var styleAttributes = DEFAULT_STYLE_ATTRIBUTES;

        if (options && options.styleAttributes) {
            styleAttributes = options.styleAttributes;
        }

        extendDirectives(DEFAULT_DIRECTIVES, directives);
        if (options && options.directives) {
            extendDirectives(options.directives, directives);
        }

        function trim(str) {
            str = str.replace(/^\s+/ig, '');
            str = str.replace(/\s+$/ig, '');
            return str;
        }

        /**
         * matching the current style attribute with the allowd list.
         * @param {DOMElement} node the element to match.
         * @returns {*}
         */
        function extractStyleAttributes(node) {
            // if no style attribute filter, no need to do this..
            if (!styleAttributes) {
                return;
            }

            // spiting the attribute into key value pair's and
            // set them into a dictionary for later scan for a match.
            var styleAttr = getAttribute(node, 'style');

            if (styleAttr) {

                var styleArr = styleAttr.split(';');
                var style = {};
                var matchAttr = [];

                // creating the dictionary of the style's
                for (var i = 0; i < styleArr.length; i++) {
                    if (styleArr[i]) {
                        var kvItem = styleArr[i].split(':');
                        if (kvItem.length && kvItem.length === 2) {
                            var key = trim(kvItem[0]).toLowerCase();
                            var val = trim(kvItem[1]).toLowerCase();
                            style[key] = val;
                        }
                    }

                }

                // iterating over the shite list and saving the matching key's
                for (var sAttr in styleAttributes) {
                    if (style.hasOwnProperty(sAttr)) {
                        for (var j = 0; j < sAttr.length; j++) {
                            if (styleAttributes[sAttr][j] === style[sAttr]) {
                                matchAttr.push(sAttr + ':' + style[sAttr]);
                                break;
                            }
                        }
                    }
                }

                if (matchAttr.length > 0) {
                    return matchAttr.join(';');
                }
            }

            return null;
        }

        function createTextElement(text, style) {
            if (style) {
                return '<span style="{style}">{text}</span>'.replace('{text}', text).replace('{style}', style);
            }
            return text;
        }

        function extractData(node, parentWrapping) {
            var html = "";
            var isWrapped = false;

            for (var child = node.firstChild; !!child; child = child.nextSibling) {
                // "nodeType === 3" equals text node type
                if (child.nodeType === 3) {
                    html += escapeHTML(child.nodeValue);
                }
                else {

                    // TODO: investigate the condition.
                    if (!child.tagName) {
                        continue;
                    }

                    var upperTagName = child.tagName.toUpperCase();
                    if (isNoContentTag(upperTagName)) {
                        continue;
                    }

                    var styleOutput = extractStyleAttributes(child);

                    if (styleOutput) {
                        isWrapped = true;
                    }

                    if (upperTagName && directives.hasOwnProperty(upperTagName)) {
                        var directiveOutput = directives[upperTagName](child);
                        html += createTextElement(directiveOutput, styleOutput);
                    }
                    else {
                        var textOutput = extractData(child, styleOutput);
                        html += createTextElement(textOutput, styleOutput);
                    }
                }
            }

            // fixing spaces issue.
            if (html) {
                var lastCharIdx = html.length - 1;
                var lastChar = html[lastCharIdx];

                if (!parentWrapping && !(lastChar == ' ' || lastChar == ';')) {
                    html += ' ';
                }
            }
            return html;
        }

        function isNoContentTag(tagName) {
            for (var i = 0; i < NO_CONTENT_TAGS.length; i++) {
                if (NO_CONTENT_TAGS[i] == tagName) {
                    return true;
                }
            }
            return false;
        }

        // TODO: unit test the escapeHTML from the utils + use the utils / replace the utils.
        function escapeHTML(html) {
            return document.createElement('div').appendChild(document.createTextNode(html)).parentNode.innerHTML;
        }

        function extendDirectives(source, target) {
            for (var item in source) {
                target[item] = source[item];
            }
        }

        function processHTML(htmlString) {
            var wrapper = document.createElement('div');
            wrapper.innerHTML = htmlString;
            return trim(extractData(wrapper));
        }

        return {
            processHTML: processHTML
        };
    };


    function getAttribute(el, attr) {
        var result = (el.getAttribute && el.getAttribute(attr)) || null;
        if (!result) {
            var attrs = el.attributes;
            var length = attrs.length;
            for (var i = 0; i < length; i++) {
                if (attr[i] !== undefined) {
                    if (attr[i].nodeName === attr) {
                        result = attr[i].nodeValue;
                    }
                }
            }
        }
        return result;
    }


    return HtmlTextFilter;

});
